import React, {useState, useEffect} from 'react'
// import { motion, useMotionValue, useTransform } from "framer-motion";
import { AppWrap, MotionWrap } from '../../wrapper';
// import styled from "styled-components";
import {motion, useMotionValue, useTransform } from 'framer-motion'
import './About.scss';
import {urlFor, client} from '../../client';

// const abouts = [
//   {title: 'Web Development', description: 'I am a good developer', imgURL: images.about01},
//   {title: 'UI/UX Designer', description: 'I am an excellent designer', imgURL: images.about02},
//   {title: 'Web Design', description: 'I am a good design developer', imgURL: images.about03},
//   {title: 'Full Stack Developer', description: 'I am a good full-stack developer', imgURL: images.about04}
// ]

const About = () => {

  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-100, 100], [30, -30]);
  const rotateY = useTransform(x, [-100, 100], [-30, 30]);
  // const centre = {textAlign: center};
  const[abouts,setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]'

    client.fetch(query)
    .then((data) => setAbouts(data))
  },[]);
  return (
    <>
    <h2 className='head-text'>Let's turn <span>Ideas</span><br/>into <span>Real Life Products</span></h2>
    {/* <h2 className='head-text'>LET'S TURN <span>IDEAS</span><br/>INTO <span>REAL LIFE PRODUCTS</span></h2> */}

      <div className='app__profiles'>
        {abouts.map((about,index) =>(
          <motion.div
          whileInView={{opacity: 1}}
          whileHover={{scale: 1.1, backgroundColor: '#b7fcfd',cursor: "grabbing" }}
          transition={{duration: 0.3 , type: 'tween'}}
          className='app__profiles-item'
          key={about.title + index}
          style={{ x, y, rotateX, rotateY, z: 100 }}
          drag
          dragElastic={0.16}
          dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }}
          // whileHover={{ cursor: "grabbing" }}

          >
            <motion.div
            style={{
              x,
              y,
              rotateX,
              rotateY,
              rotate: "0deg",
              z: 1000
            }}
            drag
            dragConstraints={{
              top:0,
              right:0,
              bottom:0,
              left:0,
          }}
            // dragElastic={0.4}
            whileHover={{ cursor: "grabbing" }}
            >
              <img src = {urlFor(about.imgUrl)} alt={about.title}/>
            </motion.div>
            <h2 className='bold-text' style = {{marginTop: 20, marginLeft: 34, marginBottom: -5 }}>{about.title}</h2>
            
            <p className='p-text' style = {{marginTop: 10, textAlign: "center", marginBottom: 10, marginLeft: 4, marginRight: 4}}>{about.description}</p>
          </motion.div>
        ) )}
      </div>
      
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
   'about',
   'app__whitebg'
);